import React, { useEffect, useRef, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { useTheme } from '@material-ui/styles'
import { materialTheme } from 'ui/themes/default'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { Container } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import DvrIcon from '@material-ui/icons/Dvr'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

import  { getAll } from 'services/apiMonitorStatus'

import {
  tableOptions,
} from './tableOptions'

import {
  tableColumns,
} from './configDataTable'

import styles from './styles'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
)

const formatDate = (date) => {
  const opts = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }

  return new Intl
    .DateTimeFormat('pt-BR', opts)
    .format(new Date(date))
}

const formatTime = (date) => {
  const opts = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }

  return new Intl
    .DateTimeFormat('pt-BR', opts)
    .format(new Date(date))
}

const subtractMinutes = (dateTime, minutes) => {
  const MS_PER_MINUTE = 60000
  return new Date(dateTime).getTime() - minutes * MS_PER_MINUTE
}

export default function ({ _location }) {
  const classes = styles()
  const theme = useTheme()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const [applications, setApplications] = useState([])
  const [startPeriod, setStartPeriod] = useState(null)
  const [endPeriod, setEndPeriod] = useState(null)
  const [nextUpdate, setNextUpdate] = useState(null)
  const [loading, setLoading] = useState(false)

  const listApplications = useCallback(() => {
    setLoading(true)

    getAll(apiKey, userId).then(result => {
      setApplications(() => result.data.apps)

      if (!_.isEmpty(result.data.last_verified)) {
        setStartPeriod(() => formatTime(subtractMinutes(result.data.last_verified, 10)))
        setEndPeriod(() => formatTime(result.data.last_verified))
        setNextUpdate(() => formatDate(result.data.next_verification))
      }

      setLoading(false)
    }).catch(err => {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao listar serviços'
      toast.error(messageError)
    })
  }, [apiKey, userId])

  const savedCallbackListApplications = useRef()

  const callbackListApplications = () => listApplications()
  useEffect(() => {
    savedCallbackListApplications.current = callbackListApplications
  })

  useEffect(() => {
    listApplications()
    const callListApplications = () => savedCallbackListApplications.current()
    const intervalId = setInterval(callListApplications, 600 * 1000)
    return () => clearInterval(intervalId)
  }, [listApplications])

  return (
    <div className="container">
      <div className={classes.titleContainer}>
        <h1 align="center" style={{ padding: '12px', fontSize: '28px' }}>
          <DvrIcon width='30px' color='primary' />
          {' '}
          Monitoramento de Saúde
        </h1>
      </div>

      <Container>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ marginBottom: 5 }}>
            <p className={classes.dateVerificationText}>
              Relatório gerado com base no período de 10 minutos
              -
              Início: {startPeriod} e Fim: {endPeriod}
            </p>

            <p className={classes.dateVerificationText}>
              Próxima Atualização:
              {' '}
              {nextUpdate}
            </p>
          </div>
        </div>

        <MuiThemeProvider theme={materialTheme}>
          <MUIDataTable
            data={applications}
            columns={tableColumns(theme)}
            options={tableOptions(loading)}
          />
        </MuiThemeProvider>
      </Container>
    </div>
  )
}
